module.exports = __webpack_public_path__ + "img/newsImg3-9.3c9a0016.png";